export default "__VITE_ASSET__96340e8d__"